// This file is autogenerated by an npm script do not edit
export const appVersion = "2.3.24";
